<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title">
        <h4>Performance Tracking By Area</h4>
      </div>
      <div class="grid-body">
        <div class="row flex">
          <div class="col-md-3">
            <h4>From Date</h4>
            <VueCtkDateTimePicker
              format="YYYY-MM-DD"
              formatted="DD MMM YYYY"
              color="coral"
              v-model="fromDate"
              :no-label="true"
              :only-date="true"
              :auto-close="true"
              label="From Date"
            />
          </div>

          <div class="col-md-3">
            <h4>To Date</h4>
            <VueCtkDateTimePicker
              format="YYYY-MM-DD"
              formatted="DD MMM YYYY"
              color="coral"
              v-model="toDate"
              :no-label="true"
              :only-date="true"
              :auto-close="true"
              label="To Date"
            />
          </div>

          <div class="col-md-3 text-align-bottom">
            <button class="btn btn-primary" @click="getDataByArea()">
              GENERATE
            </button>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-12">
            <vue-good-table
              :columns="columns"
              styleClass="table table-hover table-bordered"
              :rows="areas"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'time_delta'">
                  <span
                    :class="'text-bold ' + timeDeltaColor(props.row.time_delta)"
                    >{{ props.row.time_delta }} %</span
                  >
                </span>
                <span v-else-if="props.column.field == 'order'">
                  <router-link
                    :to="{
                      path:
                        '/performance_tracking/stations/' +
                        props.row.shirt_order_status_id,
                    }"
                    class="text-bold"
                    >{{ props.row.area }}
                  </router-link>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import AreaStatusMatching from "./tools/AreaStatusMatching.json";
import moment from "moment";
import { VueGoodTable } from "vue-good-table";
import columns from "./tools/AreaColumns.json";
import _ from "lodash";

export default {
  components: {
    VueCtkDateTimePicker,
    VueGoodTable,
  },
  data() {
    return {
      fromDate: moment().format(),
      toDate: moment().format(),
      areas: [],
      columns: columns,
    };
  },
  mounted() {
    this.getDataByArea();
  },
  methods: {
    matchStatus(status_id) {
      let index = _.findIndex(AreaStatusMatching.en, { id: status_id });
      if (index != -1) {
        return AreaStatusMatching.en[index].label;
      }
    },
    async getDataByArea() {
      let res = await axios.get("/performance_tracking/by_area", {
        params: {
          from_date: moment(this.fromDate).format("YYYY-MM-DD"),
          to_date: moment(this.toDate).format("YYYY-MM-DD"),
        },
      });
      let data = res.data;
      let tempData = [];
      data.forEach((val) => {
        val["area"] = this.matchStatus(val.shirt_order_status_id);
        tempData.push(val);
      });
      this.areas = tempData;
    },
    timeDeltaColor(value) {
      if (value > 0) {
        return "text-danger";
      } else if (value < 0) {
        return "text-success";
      }
    },
  },
};
</script>

<style scoped>
@import "~vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
.text-align-bottom {
  align-self: flex-end;
}
.flex {
  display: flex;
}
</style>
